












































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
// types
import { Folder } from "@/services/folders/types";
import { Acl, AclUserGroup, EffectivePermissionAcl, ResourceAccess, ResourceClaim, ResourceType } from "@/services/security/types";
import { userMediaLibAclFields } from "@/components/users/fields/userMediaLibAclFields";

// components
import SelectMediaFolderModal from "@/components/files/modals/SelectMediaFolderModal.vue";
import UserAclDeleteModal from "@/components/users/modals/UserAclDeleteModal.vue";
import FolderAlreadySelectedModal from "@/components/users/modals/FolderAlreadySelectedModal.vue";
import { getUserInheritedAcl } from "@/services/security/accessControlService";
import i18n from "@/i18n";

@Component({
    components: {
        SelectMediaFolderModal,
        UserAclDeleteModal,
        FolderAlreadySelectedModal
    }
})
export default class UserMediaLibraryACL extends Vue {
    @Prop() acl!: Acl[];
    @Prop() inheritedAcls!: EffectivePermissionAcl[];
    @Prop() collapseState!: boolean;

    // local state
    localCollapseState = true;
    localAcl = [] as Acl[];
    fields = userMediaLibAclFields;
    searchQuery = "";
    resourceClaim = ResourceClaim;
    resourceType = ResourceType;

    mounted() {
        this.localCollapseState = this.collapseState;
    }

    @Watch("acl")
    onAclChanged(value: boolean, oldValue: any) {
        this.localAcl = this.acl.filter(x => x.type === "Folder");
    }

    // computed
    get effectivePermissionAcls(): EffectivePermissionAcl[] { // Get effective permission acls
        var effectiveAcls = [] as EffectivePermissionAcl[];
        effectiveAcls = JSON.parse(JSON.stringify(this.inheritedFolderAcls)); // Make a copy of inheritedAcls
        // merge direct and inherited acls.
        this.localAcl.forEach((acl: Acl) => {
            const effectivePermissionAcl: EffectivePermissionAcl = {
                resourceId: acl.resourceId,
                type: acl.type,
                name: acl.name,
                claim: acl.claim,
                templateType: acl.templateType,
                resourceAccesses: [ResourceAccess.Direct],
                userGroups: []
            };
            // Add Direct Resource Access on Acl if the acl is inherited and directly added.
            const existingAclIndex = effectiveAcls.findIndex(existingAcl => existingAcl.resourceId === acl.resourceId);
            if (existingAclIndex !== -1) {
                var existedAcl = effectiveAcls[existingAclIndex];
                if (existedAcl.resourceAccesses.some(acl => acl === ResourceAccess.UserGroup)) {
                    existedAcl.resourceAccesses = [ResourceAccess.Direct, ResourceAccess.UserGroup];
                    existedAcl.claim = effectivePermissionAcl.claim; // overwrite the localAcl claim value.
                }
            } else {
                effectiveAcls.push(effectivePermissionAcl);
            }
        });
        return effectiveAcls;
    }

    get inheritedFolderAcls(): EffectivePermissionAcl[] {
        return this.inheritedAcls.filter(x => x.type === "Folder");
    }

    get filteredData() {
        return this.effectivePermissionAcls && this.effectivePermissionAcls
            .filter(x => this.searchQuery.length === 0 ||
                (x.name.toLowerCase().includes(this.searchQuery.toLowerCase())));
    }

    // methods
    openModal() {
        (this.$refs.selectMediaFolderModal as any).open();
    }

    folderSelected(folder: Folder) {
        var model = { resourceId: folder.id, name: folder.path, claim: this.resourceClaim.Access, type: this.resourceType.Folder } as Acl;
        if (this.localAcl.some(x => x.resourceId === model.resourceId)) {
            (this.$refs.folderAlreadySelected as any).open(model.name);
            return;
        };
        this.localAcl.unshift(model);
    }

    removeAccess(id: string, name: string) {
        (this.$refs.deleteAclModal as any).open(id, name);
    }

    onDelete(id: string) {
        const item = this.localAcl.find(x => x.resourceId === id);
        if (!item) {
            return;
        }
        this.localAcl.splice(this.localAcl.indexOf(item), 1);
    }

    // On radio button v-model change, update localAcl's claim value
    onFileClaimChanged(claim: ResourceClaim, id:string) {
        var index = this.localAcl.findIndex(acl => acl.resourceId === id);
        this.localAcl[index].claim = claim;
    }

    getResourceUserGroupsUrl(aclUserGroup: AclUserGroup) {
        return `/UserGroups/${aclUserGroup.groupId}/update`;
    }

    getResourceUserGroupsName(aclUserGroup: AclUserGroup) {
        return aclUserGroup.groupName;
    }

    isInheritedResource(acl: EffectivePermissionAcl): boolean {
        const hasDirectAccess = acl.resourceAccesses.includes(ResourceAccess.Direct);
        return !hasDirectAccess; // used to disable delete button if resource is inherited from user group.
    }

    formatAccess(access: Array<ResourceAccess>) {
        var formattedAccess = access.map(access => i18n.t(`acl.${ResourceAccess[access]}`));
        return formattedAccess.join(", ");
    }

    emitData() {
        this.$emit("aclUpdated", this.localAcl);
    }

    setState(state: boolean) {
        if (this.localCollapseState === state) return;

        this.localCollapseState = state;
        this.$emit("componentStateChanged", { name: "UserMediaLibraryACL", state: state });
    }
}
